import { Skeleton, TableRow } from '@mui/material';

import { TableCell } from './TableCell';
import { TableHeadProps } from './types';

export function TableSkeletonRow<T>({
  columns,
  hasActions,
  selectable,
}: Omit<TableHeadProps<T>, 'onRequestSort' | 'order' | 'orderBy'>) {
  return (
    <TableRow>
      {/* Representation of checkbox (if applicable) */}
      {Boolean(selectable) && (
        <TableCell width={30}>
          <Skeleton animation='wave' height={20} width={20} />
        </TableCell>
      )}

      {/* Representation of additional columns */}
      {columns?.map(column => (
        <TableCell key={column.key} {...column.TableCellProps}>
          <Skeleton animation='wave' variant='text' />
        </TableCell>
      ))}

      {/* Representation of action column (if applicable) */}
      {hasActions && (
        <TableCell width={30}>
          <Skeleton animation='wave' height={20} width={20} />
        </TableCell>
      )}
    </TableRow>
  );
}
